<template>
  <section class="banner">
    <div class="content-plane">
      <div class="container" style="position: relative;">
        <div>
          <div v-for="(slide, i) in slides" :key="`slide-banner-${i}`" :class="{ 'prepop': slide_index != i, 'd-none': slide_index != i && position > (100 / duration) * 2000 }" class="row cover border shadow-lg" :style="`background-image: url('${slide.imgpath}')`">
            <div class="label col-md-6" style="background-color: #000000a3 !important;">
              <div class="p-5 mb-4 rounded-3">
                <div class="container-fluid py-5">
                  <h2 class="display-7 fw-bold text-light" v-html="slide.title"></h2>
                  <p class="col-md-8 fs-4 text-muted" v-text="slide.subtitle"></p>
                  <Link class="btn btn-primary btn-lg" v-if="slide.url && slide.url[0] == '/'" :href="slide.url">Selengkapnya</Link>
                  <a class="btn btn-primary btn-lg" v-else-if="slide.url" :href="slide.url">Selengkapnya</a>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center align-items-center gap-4 slider-control">
            <span v-for="(slide, i) in slides" :key="`slide-${i}`" @click="setSlide(i)" class="cp pointer" :class="{ 'active': slide_index == i }"></span>
          </div>
        </div>
        <div class="indikator" :style="`width: ${position}%;`"></div>
      </div>
    </div>
  </section>

  <section class="pt-5 running-text">
    <div class="container">
      <div class="d-flex">
        <div class="bg-info px-4 text-white" style="padding-top: .75em;border-left: 0.5em solid #44f341;">
          <span class="fw-bold">Info</span>
        </div>
        <div class="wrap flex-fill bg-white">
          <h6>
            <span v-for="(r, i) in runningtext" :key="`runningtext-${i}`">
              <Link style="font-size: 1.2em;" v-if="r.url" v-text="r.urai"></Link>
              <span style="font-size: 1.2em;" v-else v-text="r.urai"></span>
              <span style="font-size: 1.2em;" class="px-3 sparator" v-if="runningtext.length > i+1">-</span>
            </span>
          </h6>
        </div>
      </div>
    </div>
  </section>

  <section class="pb-4">
    <div class="container">
      <div style="margin: 5em 0em; padding: 0">
        <div class="row">
          <div class="col-md-3">
            <div class="bg-white shadow-lg mx-3">
              <div class="p-5 text-center">
                <img src="/img/icons/document.png" alt="Icon" style="width: 75%;">
              </div>
              <a class="nav-link bg-info text-light" href="/infografis">Infografis</a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="bg-white shadow-lg mx-3">
              <div class="p-5 text-center">
                <img src="/img/icons/megaphone.png" alt="Icon" style="width: 75%;">
              </div>
              <a class="nav-link bg-info text-light" href="/pengumuman">Pengumuman</a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="bg-white shadow-lg mx-3">
              <div class="p-5 text-center">
                <img src="/img/icons/map.png" alt="Icon" style="width: 75%;">
              </div>
              <a class="nav-link bg-info text-light" href="/geospasial" target="_blank">Peta Sebaran Industri</a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="bg-white shadow-lg mx-3">
              <div class="p-5 text-center">
                <img src="/img/icons/worldwide.png" alt="Icon" style="width: 75%;">
              </div>
              <a class="nav-link bg-info text-light" href="http://gsx.cetakbiru.net/map/indag/">Katalog Industri dan Perdagangan</a>
            </div>
          </div>
        </div>
      </div>

      <!-- <div style="margin: 5em 0;">
        <div class="py-4">
          <h2 class="display-7 border-bottom">Cari Berdasarkan Kategori</h2>
        </div>

        <div class="row">
          <div class="col-md-4" v-for="(r, i) in penggunaan" :key="'kat-' + i">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-success py-4">
                  <Icon :icon="['fa', 'map-location-dot']" style="height: 3em" />
                </h5>
                <p class="card-text" v-text="r.urai"></p>
                <a href="#" class="card-link">{{ r.jumlah_matrix }} Titik</a>
                <a href="#" class="card-link">Lihat Map</a>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div style="margin: 5em 0;">
        <div class="py-4">
          <h2 class="display-7 border-bottom text-center">Statistik Satudata</h2>
          <hr>
        </div>

        <div class="text-center">
          <div class="card d-inline-block mx-3" style="max-width: 24em;" v-for="(r, i) in Object.keys(statistik)" :key="`statistik-${i}`">
            <div class="card-body px-5 text-center">
              <h2 class="py-3 display-4 m-0" v-text="statistik[r].count"></h2>
              <span class="fs-5 fw-bold d-block mb-2" v-text="statistik[r].title"></span>
              <p class="card-text fst-italic" v-text="statistik[r].subtitle"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-white" style="background-image: url('/img/bg-hapok.png');background-size: cover; background-position: center;">
    <div class="container">
      <div style="padding: 5em 0;">
        <div class="py-4">
          <h2 class="display-7 text-center">Harga Barang Pokok</h2>
          <hr>
        </div>

        <div class="card shadow-lg">
          <div class="card-body">
            <h6 class="text-end" v-text="'Update Terakhir: ' + (new Date()).toDateString()"></h6>
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr class="bg-info text-light">
                    <th class="text-center">No</th>
                    <th>Nama Barang Pokok</th>
                    <th class="text-center">Harga (Rp.)</th>
                    <th class="text-center">Rata-rata (Rp.)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in harga_pokok" :key="`harga-pokok-${i}`">
                    <td class="text-center" v-text="i + 1"></td>
                    <td v-text="row.urai"></td>
                    <td class="text-center" v-text="row.price"></td>
                    <td class="text-center" v-text="row.average"></td>
                  </tr>
                  <tr v-if="harga_pokok_loading">
                    <td colspan="4">
                      <span class="text-muted fst-italic">Sedang memuat data...</span>
                    </td>
                  </tr>
                  <tr v-else-if="!harga_pokok.length">
                    <td colspan="4">
                      <span class="text-muted fst-italic">Tidak Ditemukan Data!</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p class="fst-italic text-muted">Sumber Data: https://satudata.kemendag.go.id/</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="postingan">
    <div class="container">
      <div style="padding-bottom: 5em;">
        <div class="py-4">
          <h2 class="display-7 text-center mt-5">Berita Terbaru</h2>
          <hr>
        </div>

        <div class="row">
          <div class="col-md-6" v-for="(row, i) in postingan" :key="`postingan-${i}`">
            <div class="card shadow border">
              <div class="card-body">
                <div class="p-4">
                  <div class="mb-3">
                    <div v-if="row.thumbnail" :style="`min-height: 18em;background-size: cover;background-repeat: no-repeat;background-image: url(${row.thumbnail});`"></div>
                    <div v-else style="min-height: 18em;background-color: #eee;" class="d-flex justify-content-center align-items-center">
                      <p style="font-weight: bold;color: #aaa;font-size: 1.75em;">No Images</p>
                    </div>
                  </div>
                  <h4 class="mb-4">
                    <Link v-text="row.title" :href="`/postingan/${row.slug}`"></Link>
                  </h4>
                  <p class="text-muted">
                    <span v-text="(new Date(row.created_at)).toLocaleString()"></span>
                  </p>
                  <p v-text="row.shortext + '...'"></p>
                  <a class="btn btn-outline-success" :href="`/postingan/${row.slug}`">Selengkapnya</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center mt-5 mb-4">
          <Link :href="'/postingan'" class="btn btn-lg btn-outline-success">Tampilkan Lebih Banyak</Link>
        </div>

      </div>
    </div>
  </section>

</template>

<script>
import layout from '@/layout/Portal'
import axios from 'axios'
export default {
  layout,
  props: {
    postingan: Array,
    penggunaan: Array,
    slider: Array,
    runningtext: Array,
    statistik: Object,
  },
  data() {
    return {
      slides: [],
      slide_index: 0,

      position: 0,
      interval: false,
      duration: 6000,

      harga_pokok: [],
      harga_pokok_loading: false
    }
  },
  methods: {
    slideShow() {
      this.interval = setInterval(() => {
        if(this.position < 100) {
          this.position +=  (100 / this.duration) * 15;
        } else {
          this.position = 0;
          this.nextSlide();
        }
      }, 15);
    },
    nextSlide() {
      if(this.slide_index < this.slides.length-1) {
        this.slide_index += 1;
      } else {
        this.slide_index = 0;
      }
    },
    setSlide(i) {
      this.slide_index = i;
      this.position = 0;
    }
  },
  mounted() {
    this.slides = this.slider;
    if(this.slides.length > 1) {
      this.slideShow();
    }
    this.harga_pokok_loading = true;
    axios.get('/api/harga-barang-pokok')
    .then(res => {
      this.harga_pokok = res.data;
      this.harga_pokok_loading = false;
    }).catch(() => {
      this.harga_pokok_loading = false;
    });
  },
  unmounted() {
    clearInterval(this.interval);
  }
}
</script>
